import React from 'react';
import { Chip, ChipProps, SxProps, Theme } from '@mui/material';

export interface StatusBadgeProps extends Omit<ChipProps, 'color'> {
  label: string;
  status?: 'active' | 'suspended' | 'revoked' | 'pending' | 'info' | 'neutral' | 'custom';
  statusColor?: string;
  sx?: SxProps<Theme>;
}

const statusStyles = {
  active: {
    backgroundColor: '#c8e6c9',
    color: '#1b5e20',
  },
  suspended: {
    backgroundColor: '#fff3e0',
    color: '#ef6c00',
  },
  revoked: {
    backgroundColor: '#ffebee',
    color: '#c62828',
  },
  pending: {
    backgroundColor: '#e3f2fd',
    color: '#1565c0',
  },
  info: {
    backgroundColor: '#e3f2fd',
    color: '#1565c0',
  },
  neutral: {
    backgroundColor: '#f5f5f5',
    color: '#616161',
  },
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  label,
  status = 'custom',
  statusColor,
  sx = {},
  ...props
}) => {
  const getStatusStyles = () => {
    if (status === 'custom' && statusColor) {
      return {
        backgroundColor: statusColor,
        color: 'white',
      };
    }

    return statusStyles[status as keyof typeof statusStyles] ?? statusStyles.neutral;
  };

  const currentStatusStyles = getStatusStyles();

  return (
    <Chip
      label={label.toUpperCase()}
      size="small"
      sx={{
        ...currentStatusStyles,
        fontWeight: 600,
        fontSize: '12px',
        height: '24px',
        borderRadius: '4px',
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
        '& .MuiChip-label': {
          padding: '0 10px',
        },
        ...sx,
      }}
      {...props}
    />
  );
};
